import { c as _c } from "react/compiler-runtime";
import { ActionMenu, ActionMenuItem, FormInput, FormSelect, Popover } from '@systemeio/ui';
import { updateModule } from 'modules/courses/courses/curriculum/api/module-api';
import { CourseCurriculumInterface } from 'modules/courses/courses/curriculum/types/curriculum-interface';
import { CreateModuleErrorsInterface, CreateModuleInterface, ModuleInterface } from 'modules/courses/courses/curriculum/types/module-interface';
import { nonDraggableProps } from 'modules/courses/courses/curriculum/utils/non-draggable-props';
import { useSalesFunnels, useSalesFunnelSteps } from 'modules/courses/courses/hooks/use-sales-funnels';
import { CourseId } from 'modules/courses/courses/types/course-interface';
import { useRouter } from 'next/router';
import React, { memo, useEffect, useState } from 'react';
import Confirmation from 'shared/components/confirmation-modal';
import EditModal from 'shared/components/edit-modal';
import { ActionMenuLinkItem } from 'shared/components/table/components/action-menu-link-item';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { useRevalidateModules } from 'shared/hooks/use-revalidate-modules';
import { fetchWithFieldErrors } from 'shared/utils/fetch-with-errors';
import { KeyedMutator } from 'swr';
import { getCourseQuizUrl } from '../../../module/utils/get-course-quiz-url';
import { useModuleApi } from '../hooks/use-module-api';
import { QuestionMarkIcon } from '@systemeio/ui/icons';
export type ModuleActionsProps = {
  module: ModuleInterface;
  mutate: KeyedMutator<CourseCurriculumInterface>;
};
const defaultErrors: CreateModuleErrorsInterface = {
  fields: {
    name: ''
  }
};
function ModuleActions(t0) {
  const $ = _c(79);
  const {
    module,
    mutate
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const router = useRouter();
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  const [isRemoveOpen, setIsRemoveOpen] = useState(false);
  const [isQuizOpen, setIsQuizOpen] = useState(false);
  const [editErrors, setEditErrors] = useState(defaultErrors);
  const caption = t("dashboard.course.module_title");
  const captionQuiz = t("dashboard.course.module.quiz_title");
  const {
    creatingQuizForModule,
    removeModuleWithLectures
  } = useModuleApi();
  const hasLectures = module.lectures?.length > 0;
  const {
    revalidateModules
  } = useRevalidateModules();
  let t1;
  if ($[0] !== mutate || $[1] !== removeModuleWithLectures || $[2] !== revalidateModules) {
    t1 = async moduleId => {
      await removeModuleWithLectures(moduleId);
      await mutate(data => {
        if (data) {
          return {
            ...data,
            modules: data.modules.filter(module_0 => module_0.id !== moduleId)
          };
        }
      }, false);
      await revalidateModules([RequestModuleEnum.MembershipCourseCurriculum, RequestModuleEnum.MembershipCourseLecture]);
    };
    $[0] = mutate;
    $[1] = removeModuleWithLectures;
    $[2] = revalidateModules;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const onRemoveModule = t1;
  let t2;
  if ($[4] !== creatingQuizForModule || $[5] !== mutate || $[6] !== revalidateModules || $[7] !== router) {
    t2 = async moduleId_0 => {
      const response = await creatingQuizForModule(moduleId_0);
      await mutate(data_0 => {
        if (data_0) {
          return {
            ...data_0,
            modules: data_0.modules.map(module_1 => {
              if (module_1.id === moduleId_0) {
                return {
                  ...module_1,
                  quiz: response
                };
              }
              return module_1;
            })
          };
        }
      }, false);
      await revalidateModules([RequestModuleEnum.MembershipCourseCurriculum]);
      await router.push(getCourseQuizUrl(response.id));
    };
    $[4] = creatingQuizForModule;
    $[5] = mutate;
    $[6] = revalidateModules;
    $[7] = router;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const onCreateQuiz = t2;
  let t3;
  if ($[9] !== mutate || $[10] !== revalidateModules) {
    t3 = async (moduleId_1, data_1) => {
      await fetchWithFieldErrors(async () => {
        const response_0 = await updateModule(moduleId_1, data_1);
        await mutate(data_2 => {
          if (data_2) {
            return {
              ...data_2,
              modules: data_2.modules.map(module_2 => {
                if (module_2.id === moduleId_1) {
                  return response_0.data;
                }
                return module_2;
              })
            };
          }
        }, false);
      }, setEditErrors);
      await revalidateModules([RequestModuleEnum.MembershipCourseCurriculum]);
    };
    $[9] = mutate;
    $[10] = revalidateModules;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const onEditModule = t3;
  const t4 = "flex items-center justify-end";
  const t5 = nonDraggableProps;
  let t6;
  if ($[12] !== module.quiz || $[13] !== t) {
    t6 = module.quiz ? <ActionMenuLinkItem key="module-quiz" isNext={true} label={t("dashboard.course.module_quiz_title")} href={getCourseQuizUrl(module.quiz.id)} /> : <ActionMenuItem key="module-create-quiz" label={t("dashboard.course.module.create_quiz")} onClick={() => {
      setIsQuizOpen(true);
    }} />;
    $[12] = module.quiz;
    $[13] = t;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t) {
    t7 = t("dashboard.actions.title.settings");
    $[15] = t;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => {
      setIsSettingsOpen(true);
    };
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t7) {
    t9 = <ActionMenuItem key="module-settings" label={t7} onClick={t8} />;
    $[18] = t7;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t) {
    t10 = t("dashboard.actions.title.remove");
    $[20] = t;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = () => {
      setIsRemoveOpen(true);
    };
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t10) {
    t12 = <ActionMenuItem key="module-remove" label={t10} onClick={t11} />;
    $[23] = t10;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t12 || $[26] !== t6 || $[27] !== t9) {
    t13 = <ActionMenu menuItems={[t6, t9, t12]} />;
    $[25] = t12;
    $[26] = t6;
    $[27] = t9;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t) {
    t14 = t("dashboard.course.module_edit_settings_title");
    $[29] = t;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = () => {
      setIsSettingsOpen(false);
    };
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== editErrors || $[33] !== t) {
    t16 = {
      field: "name",
      onRender: (value, onChange) => <FormInput key="module-edit-name" value={value} onChange={e => onChange(e.target.value)} label={t("global.name")} error={editErrors.fields.name} />
    };
    $[32] = editErrors;
    $[33] = t;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== module.salesFunnel) {
    t17 = {
      field: "salesFunnelStep",
      onRender: (value_0, onChange_0) => <SalesFunnelStepSelector key="module-sales-funnel-step" value={value_0} salesFunnel={module.salesFunnel} onChange={onChange_0} />
    };
    $[35] = module.salesFunnel;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== t16 || $[38] !== t17) {
    t18 = [t16, t17];
    $[37] = t16;
    $[38] = t17;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] !== module.id || $[41] !== onEditModule) {
    t19 = data_3 => onEditModule(module.id, data_3);
    $[40] = module.id;
    $[41] = onEditModule;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  let t20;
  if ($[43] !== isSettingsOpen || $[44] !== module || $[45] !== t14 || $[46] !== t18 || $[47] !== t19) {
    t20 = <EditModal fullCaption={t14} opened={isSettingsOpen} onClose={t15} instance={module} editable={t18} onEdit={t19} />;
    $[43] = isSettingsOpen;
    $[44] = module;
    $[45] = t14;
    $[46] = t18;
    $[47] = t19;
    $[48] = t20;
  } else {
    t20 = $[48];
  }
  const T0 = Confirmation;
  let t21;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = () => setIsQuizOpen(false);
    $[49] = t21;
  } else {
    t21 = $[49];
  }
  let t22;
  if ($[50] !== module.id || $[51] !== onCreateQuiz) {
    t22 = () => onCreateQuiz(module.id);
    $[50] = module.id;
    $[51] = onCreateQuiz;
    $[52] = t22;
  } else {
    t22 = $[52];
  }
  let t23;
  if ($[53] !== t) {
    t23 = t("dashboard.course.module.create_modal_quiz");
    $[53] = t;
    $[54] = t23;
  } else {
    t23 = $[54];
  }
  const t24 = t("dashboard.actions.created", {
    module: captionQuiz?.toLowerCase()
  });
  let t25;
  if ($[55] !== T0 || $[56] !== isQuizOpen || $[57] !== t21 || $[58] !== t22 || $[59] !== t23 || $[60] !== t24) {
    t25 = <T0 opened={isQuizOpen} onClose={t21} onConfirm={t22} confirmationText={t23} toastCaption={t24} />;
    $[55] = T0;
    $[56] = isQuizOpen;
    $[57] = t21;
    $[58] = t22;
    $[59] = t23;
    $[60] = t24;
    $[61] = t25;
  } else {
    t25 = $[61];
  }
  const T1 = Confirmation;
  let t26;
  if ($[62] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = () => setIsRemoveOpen(false);
    $[62] = t26;
  } else {
    t26 = $[62];
  }
  let t27;
  if ($[63] !== module.id || $[64] !== onRemoveModule) {
    t27 = () => onRemoveModule(module.id);
    $[63] = module.id;
    $[64] = onRemoveModule;
    $[65] = t27;
  } else {
    t27 = $[65];
  }
  const t28 = t(hasLectures ? "dashboard.actions.remove_with_lectures_confirmation" : "dashboard.actions.remove_confirmation", {
    module: caption?.toLowerCase()
  });
  const t29 = t("dashboard.actions.removed", {
    module: caption?.toLowerCase()
  });
  let t30;
  if ($[66] !== T1 || $[67] !== isRemoveOpen || $[68] !== t26 || $[69] !== t27 || $[70] !== t28 || $[71] !== t29) {
    t30 = <T1 opened={isRemoveOpen} onClose={t26} onConfirm={t27} confirmationText={t28} toastCaption={t29} />;
    $[66] = T1;
    $[67] = isRemoveOpen;
    $[68] = t26;
    $[69] = t27;
    $[70] = t28;
    $[71] = t29;
    $[72] = t30;
  } else {
    t30 = $[72];
  }
  let t31;
  if ($[73] !== t13 || $[74] !== t20 || $[75] !== t25 || $[76] !== t30 || $[77] !== t5) {
    t31 = <div className={t4}><div {...t5}>{t13}{t20}{t25}{t30}</div></div>;
    $[73] = t13;
    $[74] = t20;
    $[75] = t25;
    $[76] = t30;
    $[77] = t5;
    $[78] = t31;
  } else {
    t31 = $[78];
  }
  return t31;
}
const getSelectDataCaptionFromName = (data: {
  id: number;
  name: string;
}[]) => {
  return data.map(instance => ({
    id: instance.id,
    caption: instance.name
  }));
};
interface SalesFunnelStepSelectorProps {
  value: number | null;
  onChange: (value: number | null) => void;
  salesFunnel: number | null;
}
const SalesFunnelStepSelector = t0 => {
  const $ = _c(41);
  const {
    value,
    onChange,
    salesFunnel
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    data: salesFunnelsData
  } = useSalesFunnels();
  const [activeFunnel, setActiveFunnel] = useState(salesFunnel);
  const {
    data: funnelStepsData,
    isLoading: isFunnelStepsLoading
  } = useSalesFunnelSteps(activeFunnel);
  let t1;
  if ($[0] !== activeFunnel || $[1] !== funnelStepsData || $[2] !== onChange || $[3] !== value) {
    t1 = () => {
      if (activeFunnel === null || !funnelStepsData) {
        return;
      }
      if (value && funnelStepsData.some(funnelStep => funnelStep.id === value)) {
        return;
      }
      onChange(funnelStepsData[0]?.id ?? null);
    };
    $[0] = activeFunnel;
    $[1] = funnelStepsData;
    $[2] = onChange;
    $[3] = value;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== activeFunnel || $[6] !== funnelStepsData || $[7] !== value) {
    t2 = [activeFunnel, funnelStepsData, value];
    $[5] = activeFunnel;
    $[6] = funnelStepsData;
    $[7] = value;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  useEffect(t1, t2);
  const t3 = !salesFunnelsData;
  let t4;
  if ($[9] !== salesFunnelsData) {
    t4 = salesFunnelsData && getSelectDataCaptionFromName(salesFunnelsData);
    $[9] = salesFunnelsData;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t) {
    t5 = t("dashboard.course.sales_page_title");
    $[11] = t;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t) {
    t6 = t("dashboard.course.sales_page_popover_title");
    $[13] = t;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t6) {
    t7 = <Popover label={t6} popoverClassName="w-[200px] sm:w-[350px]">{_temp}</Popover>;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t5 || $[18] !== t7) {
    t8 = <><div className="flex items-center gap-3">{t5}{t7}</div></>;
    $[17] = t5;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t) {
    t9 = t("dashboard.course.funnel_default_title");
    $[20] = t;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  const t10 = activeFunnel ?? undefined;
  let t11;
  if ($[22] !== onChange) {
    t11 = value_0 => {
      setActiveFunnel(value_0 ?? null);
      onChange(null);
    };
    $[22] = onChange;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t10 || $[25] !== t11 || $[26] !== t3 || $[27] !== t4 || $[28] !== t8 || $[29] !== t9) {
    t12 = <FormSelect isPreFetching={t3} data={t4} label={t8} className="sm:min-w-0" placeholder={t9} value={t10} onChange={t11} />;
    $[24] = t10;
    $[25] = t11;
    $[26] = t3;
    $[27] = t4;
    $[28] = t8;
    $[29] = t9;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== activeFunnel || $[32] !== funnelStepsData || $[33] !== isFunnelStepsLoading || $[34] !== onChange || $[35] !== t || $[36] !== value) {
    t13 = activeFunnel !== null && <FormSelect isPreFetching={isFunnelStepsLoading || !funnelStepsData} className="align-bottom sm:min-w-0" data={funnelStepsData && getSelectDataCaptionFromName(funnelStepsData)} label={t("dashboard.course.funnel_step_title")} value={value ?? undefined} onChange={value_1 => onChange(value_1 ?? null)} required={true} withoutCloseIcon={true} />;
    $[31] = activeFunnel;
    $[32] = funnelStepsData;
    $[33] = isFunnelStepsLoading;
    $[34] = onChange;
    $[35] = t;
    $[36] = value;
    $[37] = t13;
  } else {
    t13 = $[37];
  }
  let t14;
  if ($[38] !== t12 || $[39] !== t13) {
    t14 = <><div className="[&>*]:flex-1 flex flex-col justify-between gap-5">{t12}{t13}</div></>;
    $[38] = t12;
    $[39] = t13;
    $[40] = t14;
  } else {
    t14 = $[40];
  }
  return t14;
};
export default memo(ModuleActions);
function _temp(show) {
  return <QuestionMarkIcon className={`${show ? "fill-brand-primary" : "fill-fill-primary"} group-focus-visible:fill-brand-primary h-[16px] w-[16px]`} />;
}